"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("../../styles/components/common/StandaloneForm.css");
var _StandaloneModalComponent = _interopRequireDefault(require("../StandaloneModal/StandaloneModalComponent"));
require("./StandaloneKYCComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var customClass = 'kyc-standalone';
var StandaloneKYCComponent = function StandaloneKYCComponent(props) {
  return /*#__PURE__*/_react["default"].createElement(_StandaloneModalComponent["default"], _extends({
    headerText: 'KYC',
    componentProps: {
      onSubmit: props.onSubmit,
      customClass: customClass,
      showCancelButton: props.showCancelButton
    },
    customClass: customClass,
    hideClose: props.HideUpfrontCloseButton
  }, props));
};
var _default = exports["default"] = StandaloneKYCComponent;